export const JOIN_UP_ID = 2835;
export const JOIN_UP_DISCOUNT_KOEF = 0.93;
